export default __webpack_public_path__ + "static/media/Bryant_Alternate_Gray.0aadefca.png";